import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  ETimeBucketType,
  EReportingTimeWindow,
  IReportingCategoriesChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACategoriesReportChartFilters,
  TPPRetailerId,
  TSPCategoriesReportChartFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingCategoriesChartV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}:
  | {
      enabled?: boolean
      suspense?: boolean
    } & (TSPCategoriesReportChartFilters | TDACategoriesReportChartFilters) &
      TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingCategoriesChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingCategoriesChart_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerCategoriesReportChart(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
